// extracted by mini-css-extract-plugin
export var container = "_tq-0";
export var table = "_tq-2";
export var tableWrapper = "_tq-1";